'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported from "./presto.-Two-Factor-Auth-View$-Imported.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$18(failed$3) {
  this.Xl = null;
  this.Xl = failed$3;
}
export { $c_Lpresto_Freemium2FAAddView$$anon$18 as $c_Lpresto_Freemium2FAAddView$$anon$18 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$18;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$18() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$18 as $h_Lpresto_Freemium2FAAddView$$anon$18 };
$h_Lpresto_Freemium2FAAddView$$anon$18.prototype = $p;
$p.adV = (function(x) {
  return (this.Xl.aE(x.hZ) || (!x.iw.k()));
});
$p.abV = (function(x, default$1) {
  if (this.Xl.aE(x.hZ)) {
    var error$1 = this.Xl.bu(x.hZ);
    return new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$002dImported.$c_Lpresto_TwoFactorAuthView$Imported(x.hZ, x.tN, x.op, x.iw, error$1);
  } else {
    return ((!x.iw.k()) ? x : default$1.v(x));
  }
});
$p.ca = (function(x) {
  return this.adV(x);
});
$p.bk = (function(x, default$1) {
  return this.abV(x, default$1);
});
var $d_Lpresto_Freemium2FAAddView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$18, "presto.Freemium2FAAddView$$anon$18", ({
  IM: 1,
  a4: 1,
  t: 1,
  z: 1,
  a: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$18 as $d_Lpresto_Freemium2FAAddView$$anon$18 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$18.js.map
